import React from "react";
import { Box, IconButton } from "@mui/material";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DeleteIcon from '@mui/icons-material/Delete';
import HighlightEyeIcon from "../../../components/HighlightEyeIcon";

const InvoiceLineItemActions = ({ onCopy, onDelete, itemId, metadata }) => {
  // Define custom styles for the eye icon to match other icons
  const eyeIconStyles = {
    // Default color (not active/hovered)
    color: 'rgba(0, 0, 0, 0.54)',
    // Hover state
    '&:hover': {
      color: 'rgb(2, 129, 192)',
      backgroundColor: 'transparent',
    },
    // Active state will inherit from the component
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "space-between",
        height: "100%",
        width: "40px",
        gap: "8px",
        paddingTop: "30px"
      }}
    >
      <IconButton 
        onClick={onCopy}
        size="small"
        sx={{ 
          color: 'rgba(0, 0, 0, 0.54)',
          '&:hover': {
            color: 'rgb(2, 129, 192)',
          }
        }}
      >
        <ContentCopyIcon fontSize="small" />
      </IconButton>
      
      <IconButton 
        onClick={onDelete}
        size="small"
        sx={{ 
          color: 'rgba(0, 0, 0, 0.54)',
          '&:hover': {
            color: '#f44336',
          }
        }}
      >
        <DeleteIcon fontSize="small" />
      </IconButton>
      
      <HighlightEyeIcon 
        itemId={itemId || 'item-placeholder'}
        metadata={metadata || {}}
        sx={eyeIconStyles}
      />
    </Box>
  );
};

export default InvoiceLineItemActions;